import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { grey } from '@mui/material/colors'
import CssBaseline from '@mui/material/CssBaseline'

import DrawerHeader from 'components/Sidebar/DrawerHeader'
import Drawer from 'components/Sidebar/Styled/DrawerStyled'
import {
  collapsedWidth,
  normalWidth,
} from 'components/Sidebar/Styled/CustomStyles'
import SidebarLinks from 'components/Sidebar/SidebarLinks'
import Footer from 'components/Sidebar/DrawerFooter'

const Sidebar = () => {
  const [isDrawerVisible, setDrawerVisibility] = useState(true)
  const [footerHeight, setFooterHeight] = useState(128)

  useEffect(() => {
    const footer = document.getElementById('footer')?.offsetHeight || 128
    setFooterHeight(footer)
  }, [])

  useEffect(() => {
    // Minimise sidebar if the URL contains 'text_analysis'
    const url = window.location.href.includes('text_analysis')
    if (url) {
      setDrawerVisibility(false)
    }
  }, [])

  const handleDrawer = () => {
    setDrawerVisibility(!isDrawerVisible)
  }

  const handleDropdownCollapse = () => {
    if (isDrawerVisible) return

    setDrawerVisibility(true)
  }

  return (
    <Box
      sx={{
        display: {
          xs: 'none',
          sm: 'block',
        },
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Drawer variant="permanent" open={isDrawerVisible}>
          <Box
            sx={{
              backgroundColor: grey[50],
              overflow: isDrawerVisible ? 'none' : 'hidden',
              height: '100vh',
            }}
          >
            <DrawerHeader
              collapsedWidth={collapsedWidth}
              handleDrawer={handleDrawer}
              isDrawerVisible={isDrawerVisible}
            />
            <Box
              sx={{
                overflowY: 'auto',
                height: isDrawerVisible
                  ? `calc(100vh - ${footerHeight + 128}px)`
                  : 'calc(100vh - 256px)',
                backgroundColor: '#fafafa',
              }}
            >
              <SidebarLinks
                isDrawerVisible={isDrawerVisible}
                handleDropdownCollapse={handleDropdownCollapse}
              />
            </Box>
            <Footer
              isDrawerVisible={isDrawerVisible}
              width={normalWidth}
              collapsedWidth={collapsedWidth}
            />
          </Box>
        </Drawer>
      </Box>
    </Box>
  )
}

export default Sidebar
